var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniSea03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.113281,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#D38D8D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_502_15280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.113281,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#D38D8D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_502_15280)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.629 33.1156L129.826 38.9364L85.918 191.293L65.7205 185.473L109.629 33.1156ZM129.828 38.9337L150.025 44.7545L150.025 44.7576L170.221 50.578L126.312 202.935L106.115 197.114L106.116 197.111L85.9195 191.291L129.828 38.9337ZM170.222 50.5771L190.417 56.3972L190.418 56.3952L210.615 62.216L166.707 214.573L146.512 208.753L146.511 208.755L126.314 202.934L170.222 50.5771ZM230.814 68.0377L210.617 62.2169L166.708 214.574L186.906 220.395L230.814 68.0377ZM251.011 73.8612L230.814 68.0404L186.905 220.397L207.103 226.218L251.011 73.8612Z",
    fill: "#442B26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.098,
    y: 34.6777,
    width: 21.0195,
    height: 158.558,
    transform: "rotate(16.0767 116.098 34.6777)",
    fill: "#E7F1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.293,
    y: 40.5039,
    width: 21.0195,
    height: 158.558,
    transform: "rotate(16.0767 136.293 40.5039)",
    fill: "#357280"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.49,
    y: 46.3223,
    width: 21.0195,
    height: 158.558,
    transform: "rotate(16.0767 156.49 46.3223)",
    fill: "#E7F1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.689,
    y: 52.1406,
    width: 21.0195,
    height: 158.558,
    transform: "rotate(16.0767 176.689 52.1406)",
    fill: "#357280"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.084,
    y: 63.7852,
    width: 21.0195,
    height: 158.558,
    transform: "rotate(16.0767 217.084 63.7852)",
    fill: "#357280"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.887,
    y: 57.9648,
    width: 21.0195,
    height: 158.558,
    transform: "rotate(16.0767 196.887 57.9648)",
    fill: "#E7F1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.283,
    y: 69.6016,
    width: 21.0195,
    height: 158.558,
    transform: "rotate(16.0767 237.283 69.6016)",
    fill: "#E7F1F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.988 110.934C196.006 114.218 195.178 119.993 198.077 124.264L223.832 162.213L246.842 148.742L225.165 105.967C222.27 100.254 214.824 98.6974 209.882 102.773L206.241 105.777L199.988 110.934ZM246.84 148.744C250.193 154.471 247.734 162.145 241.365 165.874C234.995 169.603 227.186 167.94 223.833 162.213L246.84 148.744Z",
    fill: "#0D1F23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.166 109.548C198.29 112.84 197.502 118.517 200.334 122.74L225.965 160.964L225.965 160.964C229.318 166.692 236.699 168.605 242.534 165.189C248.369 161.773 250.393 154.355 247.042 148.628L247.046 148.626L225.215 106.084C222.273 100.351 214.756 98.8567 209.845 103.028L207.41 105.096L202.166 109.548Z",
    fill: "#DFE9EB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-1_502_15280",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.166 109.548C198.29 112.84 197.502 118.517 200.334 122.74L225.965 160.964L225.965 160.964C229.318 166.692 236.699 168.605 242.534 165.189C248.369 161.773 250.393 154.355 247.042 148.628L247.046 148.626L225.215 106.084C222.273 100.351 214.756 98.8567 209.845 103.028L207.41 105.096L202.166 109.548Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.334 122.74L201.164 122.183L200.334 122.74ZM202.166 109.548L201.519 108.786L202.166 109.548ZM225.965 160.964L226.471 161.827L227.388 161.29L226.796 160.407L225.965 160.964ZM225.965 160.964L225.46 160.101L224.597 160.607L225.102 161.47L225.965 160.964ZM247.042 148.628L246.537 147.765L245.674 148.27L246.179 149.133L247.042 148.628ZM247.046 148.626L247.551 149.489L248.367 149.011L247.935 148.17L247.046 148.626ZM225.215 106.084L226.104 105.628L226.104 105.628L225.215 106.084ZM209.845 103.028L210.492 103.79L209.845 103.028ZM207.41 105.096L206.762 104.333L207.41 105.096ZM201.164 122.183C198.615 118.382 199.325 113.273 202.814 110.311L201.519 108.786C197.255 112.407 196.388 118.651 199.503 123.297L201.164 122.183ZM226.796 160.407L201.164 122.183L199.503 123.297L225.135 161.521L226.796 160.407ZM225.46 160.101L225.46 160.101L226.47 161.827L226.471 161.827L225.46 160.101ZM225.102 161.47C228.739 167.682 236.736 169.742 243.04 166.052L242.029 164.326C236.662 167.468 229.897 165.702 226.828 160.459L225.102 161.47ZM243.04 166.052C249.334 162.367 251.545 154.343 247.905 148.123L246.179 149.133C249.241 154.368 247.403 161.179 242.029 164.326L243.04 166.052ZM246.54 147.763L246.537 147.765L247.547 149.491L247.551 149.489L246.54 147.763ZM224.325 106.541L246.156 149.083L247.935 148.17L226.104 105.628L224.325 106.541ZM210.492 103.79C214.912 100.036 221.677 101.381 224.325 106.541L226.104 105.628C222.868 99.3216 214.6 97.6773 209.197 102.265L210.492 103.79ZM208.057 105.858L210.492 103.79L209.197 102.265L206.762 104.333L208.057 105.858ZM202.814 110.311L208.057 105.858L206.762 104.333L201.519 108.786L202.814 110.311Z",
    fill: "#228093",
    mask: "url(#path-13-inside-1_502_15280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.201 114.472L213.243 116.338L210.039 139.929L209.435 138.896C208.249 136.87 207.815 134.492 208.206 132.178L211.201 114.472Z",
    fill: "#6A7173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.1 113.36L213.727 116.054L235.867 124.808L235.262 123.775C234.076 121.75 232.215 120.207 230.006 119.415L213.1 113.36Z",
    fill: "#6A7173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.059 112.509L211.768 115.428L209.996 141.264L208.438 138.606C207.288 136.642 206.842 134.344 207.173 132.093L210.059 112.509Z",
    fill: "#40C0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.059 112.509L211.768 115.428L209.996 141.264L208.438 138.606C207.288 136.642 206.842 134.344 207.173 132.093L210.059 112.509Z",
    fill: "url(#paint0_linear_502_15280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.768 115.43L210.059 112.511L209.947 113.266C209.998 113.329 211.143 115.299 211.71 116.276L211.768 115.43Z",
    fill: "#0D1F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.217 154.908C223.524 155.226 224.063 155.011 224.067 154.569V154.569C224.069 154.456 224.031 154.347 223.961 154.258L210.293 136.887L209.986 141.248L223.217 154.908Z",
    fill: "#20606D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.987 141.248L210.294 136.887L211.244 138.095L211.263 142.565L209.987 141.248Z",
    fill: "#0D1F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.561 143.587C242.687 144.011 242.237 144.375 241.849 144.163V144.163C241.75 144.108 241.672 144.022 241.629 143.918L233.172 123.496L237.125 125.364L242.561 143.587Z",
    fill: "#20606D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.025 111.361L213.734 114.28L237.131 125.382L235.575 122.722C234.426 120.758 232.641 119.244 230.515 118.431L212.025 111.361Z",
    fill: "#40C0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.025 111.361L213.734 114.28L237.131 125.382L235.575 122.722C234.426 120.758 232.641 119.244 230.515 118.431L212.025 111.361Z",
    fill: "url(#paint1_linear_502_15280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.732 114.28L212.023 111.36L212.736 111.633C212.767 111.708 213.924 113.671 214.499 114.643L213.732 114.28Z",
    fill: "#0D1F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.124 125.361L233.17 123.494L233.759 124.915L237.648 127.118L237.124 125.361Z",
    fill: "#0D1F23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.193,
    y: 111.021,
    width: 2.27007,
    height: 6.81021,
    rx: 1.13504,
    transform: "rotate(-30.3463 209.193 111.021)",
    fill: "#66BACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.502 160.67L227.715 155.908L229.504 154.861C230.595 154.222 231.566 154.545 232.105 155.458C232.635 156.37 232.433 157.376 231.335 158.019L230.414 158.558L231.357 160.169L230.502 160.67ZM230.002 157.854L230.804 157.384C231.447 157.004 231.525 156.473 231.23 155.97C230.932 155.46 230.436 155.277 229.792 155.655L228.989 156.125L230.002 157.854Z",
    fill: "#C6D6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.946 158.139C234.663 158.304 234.295 158.211 234.133 157.926C233.968 157.652 234.068 157.288 234.349 157.119C234.624 156.963 234.991 157.053 235.152 157.329C235.318 157.612 235.219 157.979 234.946 158.139Z",
    fill: "#C6D6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.27 157.293L233.483 152.532L235.271 151.484C236.363 150.845 237.334 151.169 237.873 152.081C238.402 152.994 238.201 153.999 237.103 154.642L236.182 155.181L237.125 156.793L236.27 157.293ZM235.77 154.478L236.572 154.008C237.215 153.627 237.292 153.096 236.998 152.593C236.699 152.083 236.204 151.901 235.56 152.278L234.757 152.748L235.77 154.478Z",
    fill: "#C6D6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.441 149.628L241.229 154.39L240.387 154.883L237.6 150.121L238.441 149.628Z",
    fill: "#C6D6DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.659 153.065C242.583 153.694 241.503 153.364 240.848 152.246C240.201 151.141 240.433 149.999 241.453 149.402C242.327 148.89 243.405 148.996 244.139 150.249L244.293 150.512L241.8 151.972C242.169 152.572 242.739 152.724 243.28 152.403C243.65 152.191 243.805 151.889 243.788 151.611L244.61 151.13C244.821 151.837 244.487 152.58 243.659 153.065ZM241.468 151.398L243.155 150.41C242.867 149.925 242.33 149.763 241.847 150.046C241.344 150.34 241.232 150.926 241.468 151.398Z",
    fill: "#C6D6DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.104 81.4063C233.534 77.5488 239.336 76.9353 243.496 79.9901L280.461 107.132L280.461 107.131C286.06 110.694 287.433 118.559 283.47 124.786C279.508 131.012 271.752 133.185 266.153 129.626L266.15 129.629L224.208 106.382C218.606 103.277 217.327 95.7784 221.583 90.9913L224.719 87.4633L230.104 81.4063Z",
    fill: "#0D1F23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.645 81.2601C233.078 77.5087 238.78 76.9311 242.895 79.9178L280.145 106.95L280.145 106.951C285.741 110.515 287.378 117.96 283.748 123.664C280.119 129.367 272.632 131.115 267.034 127.555L267.033 127.557L225.329 104.164C219.709 101.012 218.494 93.4452 222.844 88.6916L225.001 86.335L229.645 81.2601Z",
    fill: "#DFE9EB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-2_502_15280",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.645 81.2601C233.078 77.5087 238.78 76.9311 242.895 79.9178L280.145 106.95L280.145 106.951C285.741 110.515 287.378 117.96 283.748 123.664C280.119 129.367 272.632 131.115 267.034 127.555L267.033 127.557L225.329 104.164C219.709 101.012 218.494 93.4452 222.844 88.6916L225.001 86.335L229.645 81.2601Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.895 79.9178L242.308 80.7272L242.895 79.9178ZM229.645 81.2601L228.907 80.585L229.645 81.2601ZM280.145 106.95L280.733 106.141L281.494 106.693L280.989 107.487L280.145 106.95ZM280.145 106.951L279.607 107.795L278.764 107.258L279.301 106.414L280.145 106.951ZM267.034 127.555L266.19 127.019L266.727 126.175L267.57 126.712L267.034 127.555ZM267.033 127.557L267.876 128.094L267.368 128.892L266.543 128.429L267.033 127.557ZM225.329 104.164L224.84 105.037L224.84 105.037L225.329 104.164ZM222.844 88.6916L223.582 89.3667L222.844 88.6916ZM225.001 86.335L224.263 85.6599L225.001 86.335ZM242.308 80.7272C238.604 78.0391 233.472 78.559 230.383 81.9353L228.907 80.585C232.683 76.4584 238.955 75.8231 243.483 79.1085L242.308 80.7272ZM279.558 107.759L242.308 80.7272L243.483 79.1085L280.733 106.141L279.558 107.759ZM279.301 106.414L279.302 106.413L280.989 107.487L280.988 107.488L279.301 106.414ZM280.682 106.108C286.752 109.973 288.513 118.039 284.592 124.201L282.905 123.127C286.243 117.881 284.73 111.057 279.607 107.795L280.682 106.108ZM284.592 124.201C280.677 130.354 272.578 132.266 266.497 128.399L267.57 126.712C272.687 129.965 279.562 128.381 282.905 123.127L284.592 124.201ZM266.189 127.02L266.19 127.019L267.877 128.092L267.876 128.094L266.189 127.02ZM225.818 103.292L267.522 126.685L266.543 128.429L224.84 105.037L225.818 103.292ZM223.582 89.3667C219.667 93.645 220.76 100.455 225.818 103.292L224.84 105.037C218.658 101.569 217.321 93.2455 222.106 88.0165L223.582 89.3667ZM225.738 87.0101L223.582 89.3667L222.106 88.0165L224.263 85.6599L225.738 87.0101ZM230.383 81.9353L225.738 87.0101L224.263 85.6599L228.907 80.585L230.383 81.9353Z",
    fill: "#228093",
    mask: "url(#path-29-inside-2_502_15280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.232 90.4745L236.022 92.5844L259.715 90.2564L258.705 89.614C256.725 88.3547 254.364 87.832 252.038 88.1375L234.232 90.4745Z",
    fill: "#6A7173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.053 92.3283L235.722 93.0552L243.649 115.504L242.639 114.861C240.659 113.601 239.186 111.684 238.477 109.447L233.053 92.3283Z",
    fill: "#6A7173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.311 89.2594L235.165 91.0754L261.049 90.2626L258.45 88.6074C256.53 87.3849 254.251 86.8538 251.989 87.1019L232.311 89.2594Z",
    fill: "#40C0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.311 89.2594L235.165 91.0754L261.049 90.2626L258.45 88.6074C256.53 87.3849 254.251 86.8538 251.989 87.1019L232.311 89.2594Z",
    fill: "url(#paint2_linear_502_15280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.168 91.0743L232.314 89.2583L233.073 89.1751C233.134 89.228 235.06 90.4455 236.015 91.0477L235.168 91.0743Z",
    fill: "#0D1F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.194 103.981C274.5 104.3 274.266 104.83 273.824 104.819V104.819C273.711 104.816 273.603 104.774 273.517 104.701L256.664 90.3987L261.034 90.2538L274.194 103.981Z",
    fill: "#20606D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.034 90.2508L256.665 90.3957L257.837 91.3908L262.303 91.5744L261.034 90.2508Z",
    fill: "#0D1F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.166 122.886C262.585 123.028 262.966 122.592 262.768 122.196V122.196C262.718 122.095 262.634 122.014 262.532 121.967L242.437 112.76L244.157 116.779L262.166 122.886Z",
    fill: "#20606D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.093 91.182L233.947 92.998L244.175 116.79L241.574 115.137C239.654 113.915 238.207 112.076 237.474 109.921L231.093 91.182Z",
    fill: "#40C0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.093 91.182L233.947 92.998L244.175 116.79L241.574 115.137C239.654 113.915 238.207 112.076 237.474 109.921L231.093 91.182Z",
    fill: "url(#paint3_linear_502_15280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.946 92.9991L231.092 91.1831L231.338 91.9056C231.412 91.9389 233.331 93.1678 234.281 93.7782L233.946 92.9991Z",
    fill: "#0D1F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.154 116.778L242.434 112.759L243.832 113.399L245.89 117.367L244.154 116.778Z",
    fill: "#0D1F23"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.27007,
    height: 6.81021,
    rx: 1.13504,
    transform: "matrix(-0.536859 0.843672 0.843672 0.536859 230.859 88.3398)",
    fill: "#66BACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.781 242.053V222.256H189.547C194.045 222.256 196.629 225.031 196.629 228.928C196.629 232.879 194.004 235.6 189.438 235.6H185.883V242.053H181.781ZM185.883 232.291H188.781C191.215 232.291 192.404 230.924 192.391 228.928C192.404 226.959 191.215 225.633 188.781 225.619H185.883V232.291ZM200.594 242.299C199.309 242.299 198.27 241.273 198.297 240.002C198.27 238.744 199.309 237.719 200.594 237.732C201.811 237.719 202.863 238.744 202.863 240.002C202.863 241.273 201.811 242.299 200.594 242.299ZM206.199 242.053V222.256H213.965C218.463 222.256 221.047 225.031 221.047 228.928C221.047 232.879 218.422 235.6 213.855 235.6H210.301V242.053H206.199ZM210.301 232.291H213.199C215.633 232.291 216.822 230.924 216.809 228.928C216.822 226.959 215.633 225.633 213.199 225.619H210.301V232.291ZM227.609 222.256V242.053H223.562V222.256H227.609ZM237.48 242.354C232.928 242.34 230.139 239.4 230.152 234.697C230.139 230.117 232.969 227.014 237.316 227.014C241.213 227.014 244.289 229.475 244.289 234.533V235.682H234.145C234.145 237.924 235.471 239.305 237.562 239.318C238.943 239.305 239.928 238.703 240.324 237.814H244.18C243.605 240.562 241.145 242.34 237.48 242.354ZM234.145 233.139H240.461C240.447 231.334 239.203 230.035 237.398 230.049C235.539 230.035 234.227 231.43 234.145 233.139Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_15280",
    x1: 210.059,
    y1: 112.508,
    x2: 213.26,
    y2: 138.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41B0C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_15280",
    x1: 218.318,
    y1: 107.676,
    x2: 230.84,
    y2: 129.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40BFD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_15280",
    x1: 232.311,
    y1: 89.2598,
    x2: 258.369,
    y2: 93.4293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41B0C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_502_15280",
    x1: 227.179,
    y1: 97.3341,
    x2: 248.088,
    y2: 110.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40BFD8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniSea03);
export default __webpack_public_path__ + "static/media/mini_sea_03.e62f2f5a4461570eddd9c21a1fd06a4f.svg";
export { ForwardRef as ReactComponent };